import WalletConnectProvider from "@walletconnect/web3-provider";

// ABI
let abi = [{"inputs":[{"internalType":"address","name":"_authority","type":"address"},{"internalType":"contract Token","name":"_tokenContract","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"merkleIndex","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"index","type":"uint256"},{"indexed":false,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Claimed","type":"event"},{"inputs":[{"internalType":"uint256","name":"merkleIndex","type":"uint256"},{"internalType":"uint256","name":"index","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes32[]","name":"merkleProof","type":"bytes32[]"}],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"merkleIndex","type":"uint256"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"isClaimed","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lastRoot","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"merkleRoots","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pendingMerkleRoot","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"proposalAuthority","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"_merkleRoot","type":"bytes32"}],"name":"proposewMerkleRoot","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"reviewAuthority","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"_approved","type":"bool"}],"name":"reviewPendingMerkleRoot","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_account","type":"address"}],"name":"setProposalAuthority","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_account","type":"address"}],"name":"setReviewAuthority","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"tokenContract","outputs":[{"internalType":"contract Token","name":"","type":"address"}],"stateMutability":"view","type":"function"}]

var web3;
var contract;

async function walletConnect() {
  let button = document.querySelector('#wallet-connect-text');
  button.innerHTML = "Connecting...";

  const provider = new WalletConnectProvider({
    infuraId: "7d535ba192524314803cc7641667031a",
  });

  try {
    await provider.enable();
  } catch {
    button.innerHTML = "Connect (WalletConnect)";
    return;
  }

  web3 = new Web3(provider);
  contract = new web3.eth.Contract(abi, address);

  next(button);
}

async function metamask() {
  let button = document.querySelector('#metamask-text');
  button.innerHTML = "Connecting...";

  try {
    await ethereum.enable();
  } catch {
    button.innerHTML = "Connect (Metamask)";
    return;
  }

  web3 = new Web3(ethereum);
  contract = new web3.eth.Contract(abi, address);

  next(button);
}

const isMetaMaskConnected = async () => {
    let accounts = await web3.eth.getAccounts();
    return accounts.length > 0;
}

async function next(button) {
  if (await isMetaMaskConnected() == false) {
    return;
  }

  button.innerHTML = "Checking address...";

  let proof = await fetchProof();
  if (proof["error"] != undefined) {
    button.innerHTML = "No Doge Gold for this address";
    return;
  }

  let amount = proof["amount"];
  let index = proof["index"];
  let proofs = proof["proof"];

  if (await isClaimed(index)) {
    button.innerHTML = "Doge Gold already claimed";
    return;
  }

  button.innerHTML = "Claiming...";

  try {
    await claimTokens(index, amount, proofs);
  } catch {
    button.innerHTML = "Claim transaction rejected";
    return;
  }

  button.innerHTML = "Completed";
}

async function fetchProof() {
  let accounts = await web3.eth.getAccounts();
  let wallet = accounts[0];
  let url = `https://nfd-airdrop.herokuapp.com/proof.json?token=${token}&address=${wallet}`
  return await (await fetch(url)).json();
}

async function claimTokens(index, amount, proofs) {
  let accounts = await web3.eth.getAccounts();
  let wallet = accounts[0];
  return await contract.methods.claim(0, index, amount, proofs).send({from: wallet});
}

async function isClaimed(index) {
  return await contract.methods.isClaimed(0, index).call();
}

window.onload = function(){
  document.querySelector('#metamask').addEventListener('click', metamask);
  document.querySelector('#wallet-connect').addEventListener('click', walletConnect);
}
